import { render, staticRenderFns } from "./QuantityInput.vue?vue&type=template&id=0a10a896&scoped=true&"
import script from "./QuantityInput.vue?vue&type=script&lang=js&"
export * from "./QuantityInput.vue?vue&type=script&lang=js&"
import style0 from "./QuantityInput.vue?vue&type=style&index=0&id=0a10a896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10a896",
  null
  
)

export default component.exports